export enum VibeType {
  Serious = "Serious",
  Social = "Social",
  DateNight = "DateNight",
  AfterWork = "AfterWork",
}
